// Environment configuration that works both in development and production
// In production, values come from window._env_ (injected at runtime by env.sh)
// In development, values come from process.env (webpack)

const getEnvVar = (key, defaultValue = '') => {
  // Production: use runtime injected values from window._env_
  if (typeof window !== 'undefined' && window._env_ && window._env_[key]) {
    return window._env_[key];
  }

  // Development: use webpack process.env
  if (typeof process !== 'undefined' && process.env && process.env[key]) {
    return process.env[key];
  }

  return defaultValue;
};

const config = {
  API_URL: getEnvVar('REACT_APP_API_URL', 'http://localhost:8000'),
  API_BASE_URL: getEnvVar('REACT_APP_API_BASE_URL', 'http://localhost:8000/api/v1'),
  STRIPE_PUBLIC_KEY: getEnvVar('REACT_APP_STRIPE_PUBLIC_KEY', ''),
  GOOGLE_MAPS_API_KEY: getEnvVar('REACT_APP_GOOGLE_MAPS_API_KEY', ''),
  SITE_URL: getEnvVar('REACT_APP_SITE_URL', 'http://localhost:3000'),
  DEFAULT_LANGUAGE: getEnvVar('REACT_APP_DEFAULT_LANGUAGE', 'el'),
  ENVIRONMENT: getEnvVar('REACT_APP_ENVIRONMENT', 'development'),
};

export default config;
